import { useContext } from 'react';
import { formatCurrency } from '@erp/shared-utils';
import type { Row } from '@/lib/tanstack-table';
import { cn } from '@/lib/utils';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import { isBuyDesignated, sumPoValue } from '../utils/lineFilters';
import { calculateDraftCost } from './quantityOverride';
import { QuantityDraftContext } from './quantityDraftContext';

export function CostCell({
  row,
}: {
  row: Row<AssignmentLine>;
  table: { options: { meta?: unknown } };
}) {
  const line = row.original;
  const isTransfer = !isBuyDesignated(line);
  const currentCost = sumPoValue([line]);
  const quantityDrafts = useContext(QuantityDraftContext);
  const draftQuantity = quantityDrafts?.drafts.get(line.suggestionId) ?? null;
  const cost = calculateDraftCost({
    draftQuantity,
    unitCost: isTransfer ? null : (line.topOption?.unitCost ?? null),
    currentCost,
  });

  return (
    <span
      className={cn(
        'text-xs tabular-nums',
        isTransfer ? 'text-gray-400' : 'font-medium text-gray-700',
      )}
    >
      {formatCurrency(cost)}
    </span>
  );
}
